import { format } from 'date-fns'
import { adaptToDatabase } from '../../../utils/adaptToDatabase'
import apinode from '../../apinode'

class PedidosCompraService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/pedidos-compra/${this.idconta}`)

    return response.data
  }

  async getById(id) {
    const response = await apinode.get(`/pedidos-compra/${id}/${this.idconta}`)

    const { pedidoCompra, products, duplicatas } = response.data

    const pedidoCompraFormatted = {
      ...pedidoCompra,
      data: format(new Date(pedidoCompra.data), 'yyyy-MM-dd'),
    }

    const productsFormatted = products.map((product) => ({
      ...product,
      new: false,
    }))

    const duplicatasFormatted = duplicatas.map((duplicata) => ({
      ...duplicata,
      data: new Date(duplicata.data),
      new: false,
    }))

    return {
      pedidoCompra: pedidoCompraFormatted,
      products: productsFormatted,
      duplicatas: duplicatasFormatted,
    }
  }

  async getBySearch({ termType, termSearch, startDate, endDate }) {
    const response = await apinode.get(
      `/pedidos-compra/search/${this.idconta}?termType=${termType}&termSearch=${termSearch}&startDate=${startDate}&endDate=${endDate}`,
    )

    return response.data
  }

  async create({ order, products, duplicatas }) {
    const orderFormatted = adaptToDatabase(order, [
      'outrosvalores',
      'totalpedido',
    ])

    const productsFormatted = products.map((product) => {
      return adaptToDatabase(product, [
        'quantidade',
        'valor_total_item',
        'valorunitario',
      ])
    })

    const duplicatasFormatted = duplicatas.map((duplicata) => {
      return adaptToDatabase(duplicata, ['num_parcela', 'valor'])
    })

    const response = await apinode.post(`/pedidos-compra/${this.idconta}`, {
      order: orderFormatted,
      products: productsFormatted,
      duplicatas: duplicatasFormatted,
    })

    return response.data.idPedidoCompra
  }

  async lancarContasPagar({ idPedidoCompra, duplicatas }) {
    await apinode.post(
      `/pedidos-compra/contas_a_pagar/${idPedidoCompra}/${this.idconta}`,
      {
        duplicatas,
      },
    )
  }

  async lancarEstoque({ idPedidoCompra, products }) {
    const productsFormatted = products.map((product) => {
      return adaptToDatabase(product, [
        'quantidade',
        'valor_total_item',
        'valorunitario',
      ])
    })

    await apinode.post(
      `/pedidos-compra/estoque/${idPedidoCompra}/${this.idconta}`,
      {
        products: productsFormatted,
      },
    )
  }

  async estornarEstoque({ idPedidoCompra, products }) {
    await apinode.put(
      `/pedidos-compra/estoque/estornar/${idPedidoCompra}/${this.idconta}`,
      {
        products,
      },
    )
  }

  async update(id, { order, products, duplicatas }) {
    const orderFormatted = adaptToDatabase(order, [
      'outrosvalores',
      'totalpedido',
    ])

    const productsFormatted = products.map((product) => {
      return adaptToDatabase(product, [
        'quantidade',
        'valor_total_item',
        'valorunitario',
      ])
    })

    const duplicatasFormatted = duplicatas.map((duplicata) => {
      return adaptToDatabase(duplicata, ['num_parcela', 'valor'])
    })

    await apinode.put(`/pedidos-compra/${id}/${this.idconta}`, {
      order: orderFormatted,
      products: productsFormatted,
      duplicatas: duplicatasFormatted,
    })
  }

  async delete(id) {
    await apinode.delete(`pedidos-compra/${id}/${this.idconta}`)
  }

  async deleteProduct(id) {
    await apinode.delete(`pedidos-compra/product/${id}/${this.idconta}`)
  }

  async deleteDuplicata(id) {
    await apinode.delete(`pedidos-compra/duplicata/${id}/${this.idconta}`)
  }
}

export default new PedidosCompraService()
